import requestFunctions from "../../functions/requestFunctions";

export const state = {}
export const getters = {}
export const mutations = {}

export const actions = {

  async FETCH_DATA_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/data/' + payload.type + '/update';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_DATA_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/data/' + payload.type + '/delete';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}